import { FC, useState } from 'react';
import cn from 'classnames';
import { useAppDispatch } from 'hooks';
import { stateActions } from 'store/slices/mapV2/tabsReducer/layersReducer/stateSlice';

import { Segmented } from 'components/ui';

import './style.scss';
interface ISidebarWindowWithTabs {
  tabs: JSX.Element[];
  tabOptions: string[];
  hideOptions?: boolean;
  className?: string;
}
const SidebarWindowWithTabs: FC<ISidebarWindowWithTabs> = ({
  tabs,
  tabOptions,
  hideOptions = false,
  className,
}) => {
  const [selectedTab, setTab] = useState<string>(tabOptions[0]);
  const dispatch = useAppDispatch();
  const getIsOptionSelected = (index: number) =>
    index === tabOptions.findIndex((option) => option === selectedTab);

  const handleDragEnter = (
    e: React.DragEvent<HTMLDivElement>,
    option: string
  ) => {
    if (selectedTab === option) return;

    e.preventDefault();
    setTab(option);
    dispatch(
      stateActions.setMapDndState({ key: 'hasTabSwitched', value: true })
    );
  };

  return (
    <div className={cn('flex flex-col h-full', className)}>
      <div className="rounded-t-[10px]">
        {!hideOptions && (
          <Segmented
            options={tabOptions}
            active={selectedTab}
            onChange={setTab}
            onDragEnter={handleDragEnter}
          />
        )}
      </div>

      {tabs.map((tab, index) => (
        <div
          key={tab.key}
          className={cn({
            'w-0 h-0 overflow-hidden': !getIsOptionSelected(index),
            'flex-grow flex flex-col': getIsOptionSelected(index),
          })}
        >
          {tab}
        </div>
      ))}
    </div>
  );
};

export default SidebarWindowWithTabs;
